
const prescriptionVocabulary = {
    instructionVerbs: [
      'Tomar',
      'Aplicar',
      'Inhalar',
      'Inyectar',
    ],
    drugsUnits: [
      'gramos',
      'miligramos',
      'microgramos',
      'mililitros',
      'pastilla',
      'tableta',
      'capsula',
      'grajea',
      'disparo'

    ],
    periodicityUnits: [
        'horas',
        'dias',
        'semanas',
        'meses'
      ],
    durationUnits: [
      'dias',
      'semanas',
      'meses'
    ],
    conjunctions: [
      'durante',
      'por'
    ],
    prepositions: [
      'cada'
    ],
    indicationOfUse: [
        'Acompañar con alimentos',
        'Antes de alimentos',
        'Despues de alimentos',
        'Antes de dormir.',
        'Al despertar'
    ],
    administrationRoutes: [
      'vía oftálmica',
      'vía ótica',
      'vía nasal',
      'vía oral',
      'vía tópica',
      'vía parenteral',
      'vía rectal',
      'vía vaginal',
    ],
  };
  
  export default prescriptionVocabulary;
  